<template>
  <div class="zone832-container">
    <van-nav-bar
      title="绿色有机"
      left-text="返回"
      left-arrow
      fixed="true"
      @click-left="onClickLeft"
    />
    <div style="margin-top: 15%;">
        <div
      class="prod-items"
      v-for="item in productList"
      :key="item.prodId"
      @click="toProdPage(item.prodId)"
    >
      <div class="hot-imagecont">
        <img :src="item.pic" class="hotsaleimg" />
      </div>
      <div class="hot-text">
        <div class="hotprod-text">{{ item.prodName }}</div>
        <div class="price" style="display: flex;align-items: center;justify-content: space-between;">
          <span style="color: red;" class="big-num">￥{{ item.price }}</span>
          <span style="text-decoration: line-through; margin-left: 23px; color: darkgrey;font-size: 12px;">原价:{{ item.oriPrice }}</span>
        </div>
        <div class="prod-info" v-if="sts == 6">
          {{ item.prodCommNumber }}评价 {{ item.positiveRating }}%好评
        </div>
        <div class="prod-text-info" :class="{ 'collection-row': showCancelCollect }">
          <div v-if="item.helpProductInfo != '' && type == 1">
            <span style="font-size: 10px; font-weight: bold; color: red; margin-left: 1.25px;">{{ item.helpProductInfo }}</span>
          </div>
          <div >
            <img v-if="item.organicFood != null" src="https://img.zhujiaxian.com/2026/04/d4a83cbec6d9439787364d38bdd76c07.png" mode="widthFix" style="width: 25px; height: 25px; margin-right: 5px;" />
            <img v-if="item.landmarkProd != null" src="https://img.zhujiaxian.com/2026/04/43bc54dc313447fe8f6be9679e18b593.png" mode="widthFix" style="width: 25px; height: 25px; margin-right: 5px;" />
            <img v-if="item.greenFood != null" src="https://img.zhujiaxian.com/2026/04/76add7a0608e4cf0833925098ef66be5.png" mode="widthFix" style="width: 25px; height: 25px; margin-right: 10px;" />
          </div>
          <!-- <div v-if="showCancelCollect" class="collection-btn price small-num" @click.stop="handleCancelCollection(item.prodId)">
            取消收藏
          </div> -->
        </div>
      </div>
    </div>
    </div>
    
    <!-- 加载中提示 -->
    <div v-if="loading" class="loading-wrapper">
      <img src="https://img.zhujiaxian.com/2025/05/21f52dbb86f247098f3b3add676a775b.gif" alt="加载中" class="loading-gif">
    </div>
  </div>
</template>

<script>
import { GetFenleiDataApi } from "@/https/http";

export default {
  name: "Zone832",
  data() {
    return {
      sts: 6, // 状态值，用于控制评价信息显示
      type: 1, // 类型：1-帮扶产品，2-有机/地标/绿色产品
      showCancelCollect: true, // 是否显示取消收藏按钮
      loading: false, // 加载状态
      productList: [],
      result: {
        size: 10, // 每页显示条数
        sort: 0,
        pages: 1,
        current: 1,
        orderBy: 0,
      }
    };
  },
  mounted() {
    // 添加滚动监听
    window.addEventListener('scroll', this.handleScroll);
    // 获取产品列表数据
    this.getProductList();
  },

  beforeDestroy() {
    // 组件销毁前移除监听器
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    // 触底加载处理
    handleScroll() {
      // 获取滚动位置
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // 当距离底部小于 50px 且不在加载状态且还有更多页面时触发加载
      if (documentHeight - (scrollTop + windowHeight) < 50 && !this.loading && this.result.current < this.result.pages) {
        this.loading = true;
        console.log("触发加载更多");
        this.result.current++;
        this.getProductList();
      }
    },

    // 获取产品列表数据
    getProductList() {
      const ths = this;
      // 创建基础数据对象
      let data = {
        current: ths.result.current,
        size: ths.result.size,
        sort: ths.result.sort,
        orderBy: ths.result.orderBy,
        pages: ths.result.pages,
        specialAreaType: 2, // 832专区
      };

      GetFenleiDataApi(data).then((res) => {
        console.log(res, 'res，GetFenleiDataApi');
        
        // 支持分页加载：第一页替换，其他页追加
        if (res.data.current == 1) {
          ths.productList = res.data.records;
        } else {
          ths.productList = ths.productList.concat(res.data.records);
        }
        // 更新总页数
        ths.result.pages = res.data.pages;
        // 加载完成，重置loading状态
        ths.loading = false;
      }).catch(err => {
        console.error('加载数据失败:', err);
        ths.loading = false;  // 出错时也要重置 loading 状态
      });
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
    // 跳转到产品详情页
    toProdPage(prodId) {
      console.log("跳转到产品详情页:", prodId);
      this.$router.push({ path: "/productDetail", query: { id: prodId } });
    },
    // 取消收藏
    handleCancelCollection(prodId) {
      console.log("取消收藏:", prodId);
      // 这里可以添加取消收藏的逻辑
    }
  }
};
</script>

<style lang="less" scoped>
.zone832-container {
  background: #f4f4f4;
  min-height: 100vh;
  padding: 10px;
  font-size: 0; /* 消除inline-block元素间的空格 */
}

.prod-items {
  width: calc(50% - 15px); /* 两列布局，减去margin */
  display: inline-block;
  background: #fff;
  padding: 10px;
  box-sizing: border-box;
  margin-left: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  font-size: 14px; /* 恢复字体大小 */
  vertical-align: top; /* 顶部对齐 */
}

.hot-imagecont .hotsaleimg {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}

.hot-text .hotprod-text {
  height: 38px;
  line-height: 19px;
  font-size: 14px;
  display: -webkit-box;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: #000;
}

.prod-items .hot-imagecont {
  text-align: center;
  font-size: 0;
  width: 152px;
  height: 152px;
}

.prod-items .hot-text {
  margin-top: 10px;
}

.prod-items .hot-text .prod-info {
  font-size: 10px;
  color: #777;
  margin-top: 4px;
  margin-left: 7.5px;
}

.prod-items .hot-text .prod-text-info {
  position: relative;
  height: 20px;
  line-height: 20px;
  font-family: Arial;
  margin-top: 10px;
}

.collection-row {
  display: flex;
  justify-content: space-between;
}

.prod-items .hot-text .prod-text-info .price {
  color: #e43130;
}

.deadline-price {
  font-size: 11px;
  margin-right: 2.5px;
}

.basket-img {
  width: 25px;
  height: 25px;
  position: absolute;
  right: 0;
  bottom: 3.5px;
  padding: 4px;
}

.symbol {
  font-size: 12px;
}

.big-num {
  font-size: 15px;
}

.collection-btn {
  font-size: 12px;
  padding: 2px 8px;
  background: #e43130;
  color: #fff;
  border-radius: 4px;
}

.small-num {
  font-size: 12px;
}

/* 加载中样式 */
.loading-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.loading-gif {
  width: 50px;
  height: 50px;
  display: inline-block;
}
</style>
